import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formatNumber, getDecimals } from '../../../service/market';

import Link from '../../../components/Link';
import table from '../../../styles/table/flextable';

export default class FeedRow extends Component {
    static propTypes = {
        ITEM: PropTypes.string.isRequired,
        SECTOR: PropTypes.string.isRequired,
        TIME: PropTypes.number,
        SECURITYNAME: PropTypes.string,
        FUNDMGRNAME: PropTypes.string,
        PRICE: PropTypes.number,
        QUOTATIONCURRENCY: PropTypes.string,
        PRICECHANGEPCT: PropTypes.number,
        RET1WEEK: PropTypes.number,
        RET1M: PropTypes.number,
        RET6M: PropTypes.number,
        RETGAVG1YR: PropTypes.number,
        RETGAVG3YR: PropTypes.number,
        RETGAVG5YR: PropTypes.number,
        RETGAVG10YR: PropTypes.number,

        period: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = ({
            sign: table.neutral,
        });

        this._setSign = p => {
            const change = this._getActiveReturn(p);

            let sign;
            if (change) {
                sign = change >= 0 ? table.positive : table.negative;
            } else {
                sign = table.neutral;
            }

            this.setState({ sign });
        };

        this._getActiveReturn = (p) => {
            const periods = ['1WEEK', '1M', '6M', 'GAVG1YR', 'GAVG3YR', 'GAVG5YR', 'GAVG10YR'];
            if (periods.indexOf(p.period) > -1) {
                const result = ['RET', p.period].join('');
                return p[result];
            }

            return p.PRICECHANGEPCT;
        };
    }

    componentDidMount() {
        this._setSign(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.period !== this.props.period
            || nextProps.PRICECHANGEPCT !== this.props.PRICECHANGEPCT
        ) {
            this._setSign(nextProps);
        }
    }

    renderName() {
        return (
            <div className={[table.tableCell, table.name, table.ellipsis].join(' ')}>
                {this.props.SECURITYNAME}
            </div>
        );
    }

    renderPrice() {
        const price = this.props.PRICE;

        const decimals = getDecimals(price);

        return (
            <div className={[table.tableCell, table.withCurrencyName].join(' ')}>
                <span>{formatNumber(price, decimals)}</span>
                <span>{this.props.QUOTATIONCURRENCY}</span>
            </div>
        );
    }

    renderChangePct() {
        const change = this._getActiveReturn(this.props);
        const decimals = getDecimals(change);

        return (
            <div className={[table.tableCell, table.change, this.state.sign].join(' ')}>
                {formatNumber(change, decimals, true)}
            </div>
        );
    }

    render() {
        const { ITEM, SECTOR } = this.props;
        const symbol = [ITEM, SECTOR].join('.');

        return (
            <li className={table.tableRow}>
                <Link
                    className={table.tableRowLink}
                    to={`/instrument/${encodeURIComponent(symbol).toUpperCase()}`}
                >
                    {this.renderName()}
                    {this.renderPrice()}
                    {this.renderChangePct()}
                </Link>
            </li>
        );
    }

}



/** WEBPACK FOOTER **
 ** /src/shared/components/table/feed/FundRow.js
 **/